export default defineAppConfig({
	ui: {
		colors: {
			primary: 'amber',
			neutral: 'slate',
		},
		container: {
			base: 'max-w-[1536px] w-full px-4 sm:px-6 lg:px-14',
		},
		button: {
			slots: {
				base: 'disabled:opacity-50',
			},
			defaultVariants: {
				size: 'lg',
			},
		},
		input: {
			slots: {
				root: 'w-full',
			},
			defaultVariants: {
				size: 'lg',
			},
		},
		selectMenu: {
			defaultVariants: {
				size: 'lg',
			},
		},
		select: {
			defaultVariants: {
				size: 'lg',
			},
		},
		textarea: {
			slots: {
				root: 'w-full',
			},
		},
		card: {
			variants: {
				variant: {
					outline: {
						root: 'shadow-sm',
					},
				},
			},
		},
		tabs: {
			compoundVariants: [
				{
					color: 'neutral',
					class: {
						trigger: 'data-[state=active]:text-default',
						indicator: 'bg-default',
					},
				},
			],
		},
		avatar: {
			variants: {
				size: {
					'2xl': {
						root: 'size-16',
					},
					'3xl': {
						root: 'size-20',
					},
				},
			},
		},
	},
});
